import { useCallback, useState } from "react";

export type TAsyncStatus = "idle" | "pending" | "complete" | "error";

export const useAsyncAction = <TArgs extends unknown[], TResult>(
  asyncFn: (...args: TArgs) => Promise<TResult>,
): [TAsyncStatus, (...args: TArgs) => Promise<TResult>] => {

  const [ status, setStatus ] = useState<TAsyncStatus>("idle");

  const run = useCallback(
    async (...args: TArgs): Promise<TResult> => {
      setStatus("pending");
      try {
        const result = await asyncFn(...args);
        setStatus("complete");
        return result;
      } catch (e) {
        setStatus("error");
        throw e;
      }
    },
    [ asyncFn ],
  );

  return [ status, run ];

};
